import _ from 'lodash';

import { AiChatActivityPhase } from 'constants/aiChat';

import {
  ACTIVITY_BAR_LABELS,
  PULSING_PHASES,
  RUNNING_TOOL_LABEL_MAX_LENGTH,
} from './AiChatActivityBar.constants';
import {
  activityIconPulseStyles,
  activityIconStyles,
  activityTextIdleStyles,
  activityTextStyles,
} from './AiChatActivityBar.styles';

const truncateToolLabel = name => {
  if (_.isNil(name)) {
    return null;
  }

  const trimmed = name.trim();

  if (trimmed.length <= RUNNING_TOOL_LABEL_MAX_LENGTH) {
    return trimmed;
  }

  return `${trimmed.slice(0, RUNNING_TOOL_LABEL_MAX_LENGTH - 1).trimEnd()}\u2026`;
};

export const resolveActivityState = (phase, runningToolFriendlyName) => {
  const fallbackLabel = ACTIVITY_BAR_LABELS[phase] ?? ACTIVITY_BAR_LABELS[AiChatActivityPhase.IDLE];
  const truncatedToolName = truncateToolLabel(runningToolFriendlyName);
  const isRunningTool = phase === AiChatActivityPhase.RUNNING_TOOL;
  // A truncated name already carries a trailing ellipsis (truncateToolLabel);
  // don't append the progress ellipsis on top of it or the bar renders a
  // double "\u2026\u2026" (e.g. "Running Open the loan section for editing b\u2026\u2026").
  const runningToolLabel =
    truncatedToolName && !truncatedToolName.endsWith('\u2026')
      ? `Running ${truncatedToolName}\u2026`
      : `Running ${truncatedToolName}`;
  const statusText = isRunningTool && truncatedToolName ? runningToolLabel : fallbackLabel;

  const isPulsing = PULSING_PHASES.has(phase);

  return {
    statusText,
    iconSx: isPulsing ? activityIconPulseStyles : activityIconStyles,
    textSx: isPulsing ? activityTextStyles : activityTextIdleStyles,
  };
};
